import React from 'react';
import InvoicingTableHeader from './InvoicingTableHeader';
import InvoicingTableItem, { InvoicedOrder } from './InvoicingTableItem';
// @ts-ignore
import styles from './InvoicingTable.module.scss';
import {
	OrderLog,
	OrderMember,
	OrderMemberType,
} from '../../../../../graphql/graphql';
import { getDate } from '../../../../../Helpers/date.helper';
import { PaymentState } from '../../../Enums/paymentState.enum';

interface Props {
	flatData: any;
	onRefresh: () => void;
}

const InvoicingTable: React.FC<Props> = ({ flatData }) => {
	return (
		<table className={styles.wrapper}>
			<InvoicingTableHeader />
			<tbody>
				{flatData?.map((itemData: any) => {
					const item: InvoicedOrder = {
						id: itemData?.id,
						invoices: itemData?.invoices as {
							id: string;
							url: string;
							number: string;
						}[],
						createDate: getDate(itemData?.issueDate),
						state: itemData?.orderLogs?.find(
							(log: OrderLog) => log.type === 'paid',
						)
							? PaymentState.PAID
							: PaymentState.UNPAID,
						customer:
							itemData?.orderMembers?.find(
								(orderMember: OrderMember) =>
									orderMember?.type === OrderMemberType.Payer,
							)?.user?.profile?.fullName ?? '',
						invoiceCreatedBy:
							itemData?.orderMembers?.find(
								(orderMember: OrderMember) =>
									orderMember?.type === OrderMemberType.Issuer,
							)?.user?.profile?.fullName ?? '',
						description: itemData?.name,
						amount: itemData?.priceInvoicing,
						commission: itemData?.commission,
					};

					return (
						<React.Fragment key={item.id}>
							<InvoicingTableItem item={item} />
						</React.Fragment>
					);
				})}
			</tbody>
		</table>
	);
};

export default InvoicingTable;
